module.exports = __webpack_public_path__ + "img/medal8.3598c6c4.png";